import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	pirConfigurationErrorFlagText: {
		id: 'servicedesk-incident-management-settings.services.actions.set-pir-configuration.pir-configuration-error-flag-text',
		defaultMessage: "We couldn't save Incident Reviews configuration",
		description:
			'The title text in the error flag if the PIR configuration status can not be saved.',
	},
});
